// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\PublicReservationListResponse

import { hydrateBusiness, type Business, type BusinessApiResponse } from './business.gen';
import { hydrateBooking, type Booking, type BookingApiResponse } from './booking.gen';
import { hydrateSessionInstance, type SessionInstance, type SessionInstanceApiResponse } from './sessionInstance.gen';
import { hydrateOffer, type Offer, type OfferApiResponse } from './offer.gen';
import { hydratePromoCode, type PromoCode, type PromoCodeApiResponse } from './promoCode.gen';
import { hydrateAgendaSetting, type AgendaSetting, type AgendaSettingApiResponse } from './agendaSetting.gen';

export type PublicReservationListApiResponse = {
	business: BusinessApiResponse;
	bookings: BookingApiResponse[];
	sessionInstances: SessionInstanceApiResponse[];
	offers: OfferApiResponse[];
	promoCodes: PromoCodeApiResponse[];
	agendaSettings: AgendaSettingApiResponse;
};

export type PublicReservationList = {
	business: Business;
	bookings: Booking[];
	sessionInstances: SessionInstance[];
	offers: Offer[];
	promoCodes: PromoCode[];
	agendaSettings: AgendaSetting;
};

export function hydratePublicReservationList(data: PublicReservationListApiResponse): PublicReservationList {
	return {
		...data,
		business: hydrateBusiness(data.business),
		bookings: data.bookings.map(hydrateBooking),
		sessionInstances: data.sessionInstances.map(hydrateSessionInstance),
		offers: data.offers.map(hydrateOffer),
		promoCodes: data.promoCodes.map(hydratePromoCode),
		agendaSettings: hydrateAgendaSetting(data.agendaSettings),
	};
}